import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AsociacionesComponent } from './asociaciones.component';
import { EstadoCuentaComponent } from './reportes/estado-cuenta/estado-cuenta.component';
import { TarjetasCreditoActualizadasComponent } from '../seguimiento/reportes/tarjetas-credito-actualizadas/tarjetas-credito-actualizadas.component';

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '', component: AsociacionesComponent
                ,
                children: [
     			    { path: '', redirectTo: 'reportes/estado-cuenta', pathMatch: 'full' },
                    { path: 'reportes/estado-cuenta', component: EstadoCuentaComponent },
                    { path: 'tarjetas-credito-actualizadas', component: TarjetasCreditoActualizadasComponent },
                ]
            },
            {path: '**', redirectTo: '/notfound'},
        ])
    ],
    exports: [RouterModule]
})
export class AsociacionesRoutingModule {
}
